import { Button } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";

interface Props {
  id?: string;
  path: string;
  name?: string;
  icon?: string;
  onClick?: any;
}

const LinkButton: FC<Props> = ({ id, path, name, icon, onClick }) => {
  return (
    <Link to={onClick ? "#" : path}>
      <Button
        type="button"
        id={id}
        onClick={onClick}
        className="btn btn-light "
      >
        <i className={icon} />
        {name}
      </Button>
    </Link>
  );
};
export default LinkButton;
